<template>
    <div>
        <Head title="About us" />
        <!-- Start Hero -->
        <section class="relative table w-full py-20 lg:py-24 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 text-center mt-10">
                    <h3 class="text-3xl leading-normal font-semibold">About Us</h3>
                </div><!--end grid-->
            </div><!--end container-->

        </section><!--end section-->
        <div class="relative">
            <div class="shape absolute right-0 sm:-bottom-px -bottom-[2px] left-0 overflow-hidden z-1 text-white dark:text-slate-900">
                <svg class="w-full h-auto" viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                </svg>
            </div>
        </div>
        <!-- End Hero -->

        <!-- Start Section-->
        <section class="relative md:py-24 py-16">
            <div class="container">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                    <div class="lg:col-span-5 md:col-span-6">
                        <div class="grid grid-cols-12 gap-6 items-center">
                            <div class="col-span-6">
                                <div class="grid grid-cols-1 gap-6">
                                    <img src="assets/images/about/ab03.jpg" class="shadow rounded-md" alt="">
                                    <img src="assets/images/about/ab02.jpg" class="shadow rounded-md" alt="">
                                </div>
                            </div>

                            <div class="col-span-6">
                                <div class="grid grid-cols-1 gap-6">
                                    <img src="assets/images/about/ab01.jpg" class="shadow rounded-md" alt="">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lg:col-span-7 md:col-span-6">
                        <div class="lg:ml-5">
                            <div class="flex mb-4">
                                <span class="text-indigo-600 text-2xl font-bold mb-0"><span class="counter-value text-6xl font-bold" data-target="15">1</span>+</span>
                                <span class="self-end font-medium ml-2">Years <br> Experience</span>
                            </div>

                            <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Who we are ?</h3>

                            <p class="text-slate-400 max-w-xl">Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect. Dummy text is text that is used in the publishing industry or by web designers to occupy the space which will later be filled with 'real' content.</p>

                            <div class="mt-6">
                                <a href="contact-one.html" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2"><i class="uil uil-envelope"></i> Contact us</a>
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <!-- Business Partner -->
            <div class="container mt-8">
                <div class="grid md:grid-cols-6 grid-cols-2 justify-center gap-[30px]">
                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/amazon.svg" class="h-6" alt="">
                    </div>

                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/google.svg" class="h-6" alt="">
                    </div>

                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/lenovo.svg" class="h-6" alt="">
                    </div>

                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/paypal.svg" class="h-6" alt="">
                    </div>

                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/shopify.svg" class="h-6" alt="">
                    </div>

                    <div class="mx-auto mt-8">
                        <img src="assets/images/client/spotify.svg" class="h-6" alt="">
                    </div>
                </div><!--end grid-->
            </div><!--end container-->
            <!-- Business Partner -->
        </section><!--end section-->
        <!-- End Section-->

        <!-- Start -->
        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800">
            <div class="container">
                <div class="grid grid-cols-1 pb-8 text-center">
                    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Key Features</h3>

                    <p class="text-slate-400 max-w-xl mx-auto">Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect.</p>
                </div><!--end grid-->

                <div class="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-[30px] mt-8">
                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="monitor" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Fully Responsive</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="heart" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Browser Compatibility</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="eye" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Retina Ready</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="layout" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Based On Tailwindcss 3</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="feather" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Feather Icons</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="code" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Built With SASS</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="user-check" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">W3c Valid Code</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="globe" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Browsers Compatible</h4>
                        </div>
                    </div>

                    <div class="flex transition-all duration-500 hover:scale-105 shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 ease-in-out items-center p-3 rounded-md bg-white dark:bg-slate-900">
                        <div class="flex items-center justify-center h-[45px] min-w-[45px] -rotate-45 bg-gradient-to-r from-transparent to-indigo-600/10 text-indigo-600 text-center rounded-full mr-3">
                            <i data-feather="settings" class="h-5 w-5 rotate-45"></i>
                        </div>
                        <div class="flex-1">
                            <h4 class="mb-0 text-lg font-medium">Easy to customize</h4>
                        </div>
                    </div>
                </div><!--end grid-->

                <div class="grid grid-cols-1 justify-center">
                    <div class="mt-6 text-center">
                        <a href="page-services.html" class="btn bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md mr-2 mt-2">See More <i class="uil uil-arrow-right"></i></a>
                    </div>
                </div>
            </div><!--end contanier-->
        </section><!--end section-->
        <!-- End -->

        <!-- Start -->
        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800 md:pt-0 pt-0">
            <div class="container">
                <div class="grid grid-cols-1 justify-center">
                    <div class="relative z-1">
                        <div class="grid lg:grid-cols-12 grid-cols-1 md:text-left text-center justify-center">
                            <div class="lg:col-start-2 lg:col-span-10">
                                <div class="relative">
                                    <img src="assets/images/cta-bg.jpg" class="rounded-md shadow-lg" alt="">
                                    <div class="absolute bottom-2/4 translate-y-2/4 right-0 left-0 text-center">
                                        <a href="#!" data-type="youtube" data-id="yba7hPeTSjk"
                                           class="lightbox h-20 w-20 rounded-full shadow-lg dark:shadow-gray-800 inline-flex items-center justify-center bg-white dark:bg-slate-900 text-indigo-600">
                                            <i class="mdi mdi-play inline-flex items-center justify-center text-2xl"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="content md:mt-8">
                            <div class="grid lg:grid-cols-12 grid-cols-1 md:text-left text-center justify-center">
                                <div class="lg:col-start-2 lg:col-span-10">
                                    <div class="grid md:grid-cols-2 grid-cols-1 items-center">
                                        <div class="mt-8">
                                            <div class="section-title text-md-start">
                                                <h6 class="text-white/50 text-lg font-semibold">Team</h6>
                                                <h3 class="md:text-3xl text-2xl md:leading-normal leading-normal font-semibold text-white mt-2">Meet Experience <br> Team Member</h3>
                                            </div>
                                        </div>

                                        <div class="mt-8">
                                            <div class="section-title text-md-start">
                                                <p class="text-white/50 max-w-xl mx-auto mb-2">Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect.</p>
                                                <a href="" class="text-white">Read More <i class="uil uil-angle-right-b align-middle"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!--end row -->
            </div><!--end container-->

            <div class="absolute bottom-0 left-0 right-0 sm:h-2/3 h-4/5 bg-gradient-to-b from-indigo-500 to-indigo-600"></div>
        </section><!--end section-->
        <!-- End -->

        <!-- Start -->
        <section class="relative md:py-24 py-16 bg-gray-50 dark:bg-slate-800 md:pb-0 pb-0">
            <div class="container">
                <div class="grid grid-cols-1 pb-8 text-center">
                    <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Our Professional Team</h3>

                    <p class="text-slate-400 max-w-xl mx-auto">Start working with HelpDesk that can provide everything you need to generate awareness, drive traffic, connect.</p>
                </div><!--end grid-->

                <div class="grid md:grid-cols-12 grid-cols-1 mt-8 gap-[30px]">
                    <div class="lg:col-span-3 md:col-span-6">
                        <div class="team p-6 rounded-md border border-gray-100 dark:border-gray-700 group bg-white dark:bg-slate-900">
                            <img src="assets/images/client/01.jpg" class="h-24 w-24 rounded-full shadow-md dark:shadow-gray-800" alt="">

                            <div class="content mt-4">
                                <a href="" class="text-lg font-medium hover:text-indigo-600 block">Ronny Jofra</a>
                                <span class="text-slate-400 block">C.E.O.</span>

                                <p class="text-slate-400 mt-4">If the distribution of letters and 'words' is random</p>

                                <ul class="list-none mt-4">
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="facebook" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="instagram" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="twitter" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="linkedin" class="h-4 w-4"></i></a></li>
                                </ul><!--end icon-->
                            </div>
                        </div>
                    </div>

                    <div class="lg:col-span-3 md:col-span-6">
                        <div class="team p-6 rounded-md border border-gray-100 dark:border-gray-700 group bg-white dark:bg-slate-900">
                            <img src="assets/images/client/02.jpg" class="h-24 w-24 rounded-full shadow-md dark:shadow-gray-800" alt="">

                            <div class="content mt-4">
                                <a href="" class="text-lg font-medium hover:text-indigo-600 block">Aliana Rosy</a>
                                <span class="text-slate-400 block">HR</span>

                                <p class="text-slate-400 mt-4">If the distribution of letters and 'words' is random</p>

                                <ul class="list-none mt-4">
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="facebook" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="instagram" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="twitter" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="linkedin" class="h-4 w-4"></i></a></li>
                                </ul><!--end icon-->
                            </div>
                        </div>
                    </div>

                    <div class="lg:col-span-3 md:col-span-6">
                        <div class="team p-6 rounded-md border border-gray-100 dark:border-gray-700 group bg-white dark:bg-slate-900">
                            <img src="assets/images/client/03.jpg" class="h-24 w-24 rounded-full shadow-md dark:shadow-gray-800" alt="">

                            <div class="content mt-4">
                                <a href="" class="text-lg font-medium hover:text-indigo-600 block">Sofia Razaq</a>
                                <span class="text-slate-400 block">C.O.O.</span>

                                <p class="text-slate-400 mt-4">If the distribution of letters and 'words' is random</p>

                                <ul class="list-none mt-4">
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="facebook" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="instagram" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="twitter" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="linkedin" class="h-4 w-4"></i></a></li>
                                </ul><!--end icon-->
                            </div>
                        </div>
                    </div>

                    <div class="lg:col-span-3 md:col-span-6">
                        <div class="team p-6 rounded-md border border-gray-100 dark:border-gray-700 group bg-white dark:bg-slate-900">
                            <img src="assets/images/client/04.jpg" class="h-24 w-24 rounded-full shadow-md dark:shadow-gray-800" alt="">

                            <div class="content mt-4">
                                <a href="" class="text-lg font-medium hover:text-indigo-600 block">Micheal Carlo</a>
                                <span class="text-slate-400 block">Director</span>

                                <p class="text-slate-400 mt-4">If the distribution of letters and 'words' is random</p>

                                <ul class="list-none mt-4">
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="facebook" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="instagram" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="twitter" class="h-4 w-4"></i></a></li>
                                    <li class="inline"><a href="" class="btn btn-icon btn-sm border border-gray-100 dark:border-gray-800 rounded-md hover:border-indigo-600 dark:hover:border-indigo-600 hover:bg-indigo-600 hover:text-white"><i data-feather="linkedin" class="h-4 w-4"></i></a></li>
                                </ul><!--end icon-->
                            </div>
                        </div>
                    </div>
                </div><!--end grid-->
            </div><!--end container-->

            <div class="container md:mt-24 mt-16">
                <div class="grid md:grid-cols-12 grid-cols-1 items-center">
                    <div class="lg:col-span-5 md:col-span-6 md:order-1 order-2">
                        <div class="relative overflow-hidden after:content-[''] after:absolute after:h-40 after:w-40 after:bg-red-600/5 after:top-5 after:left-0 after:right-0 after:mx-auto after:-z-0 after:rounded-3xl after:animate-[spin_10s_linear_infinite]">
                            <img src="assets/images/hero2.png" class="relative z-1" alt="">
                        </div>
                    </div>

                    <div class="lg:col-span-7 md:col-span-6 md:order-2 order-1">
                        <div class="tiny-single-item">
                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/amazon.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Thomas Israel</h6>
                            </div>

                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/google.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Carl Oliver</h6>
                            </div>

                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/lenovo.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Barbara McIntosh</h6>
                            </div>

                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/paypal.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Jill Webb</h6>
                            </div>

                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/shopify.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Dean Tolle</h6>
                            </div>

                            <div class="tiny-slide text-center">
                                <img src="assets/images/client/spotify.svg" class="h-6 mx-auto" alt="">
                                <p class="text-slate-400 mt-6">" If the distribution of letters and 'words' is random, the reader will not be distracted from making a neutral judgement on the visual impact and readability of the typefaces (typography), or the distribution of text on the page consists of a more or less random series of words or syllables. "</p>
                                <h6 class="text-indigo-600 font-semibold mt-3">- Christa Smith</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!--end container-->
        </section><!--end section-->
        <!-- End -->
    </div>
</template>
<script>
import Layout from '@/Shared/Landing/Layout'
import Icon from '@/Shared/Icon'
import { Head } from '@inertiajs/vue3'
export default {
    layout: Layout,
    components: {
        Icon,
        Head,
    },
}
</script>
